import { memo } from "react";
import SlDialog from "@shoelace-style/shoelace/dist/react/dialog";
import "./TransitionModal.css";
import SlSpinner from "@shoelace-style/shoelace/dist/react/spinner";
import Translatable from "../Translatable/Translatable";

interface IPropsTransitionModal {
  open: boolean;
  text: string;
}

/**
 * Versión optimizada de TransitionModal que evita re-renders innecesarios.
 * Usa React.memo para solo actualizarse cuando cambian las props 'open' o 'text'.
 */
const OptimizedTransitionModal = memo(
  ({ open, text }: IPropsTransitionModal) => {
    return (
      <SlDialog open={open} className="transition-modal" noHeader onSlRequestClose={(e) => e.preventDefault()}>
        {text === "logoAnimado" ? (
          <img src="/202406_Loading-Blanco_1x1.gif" alt="Cargando" className="transition-modal-loading-gif" />
        ) : (
          <>
            <SlSpinner
              style={{
                fontSize: "3rem",
                //@ts-ignore
                "--indicator-color": "#00C4B3",
                "--track-color": "#ccebe8",
              }}
            />
            <div className="transition-modal-text">
              <Translatable as="span">{text}</Translatable>
            </div>
          </>
        )}
      </SlDialog>
    );
  },
  (prevProps, nextProps) => {
    // Solo re-renderizar si cambian open o text
    return prevProps.open === nextProps.open && prevProps.text === nextProps.text;
  }
);

OptimizedTransitionModal.displayName = "OptimizedTransitionModal";

export default OptimizedTransitionModal;

